const { gsap } = require('gsap');
import { ScrollTrigger } from "gsap/ScrollTrigger";

const windowScrollPage = function () {

	var objStage = {};

	//-> header small header
	const scrollHeader = () => {
		ScrollTrigger.create({
			trigger: '#webdoor',
			start: 'bottom center',
			end: 99999,
			toggleClass: { className: 'scrolling', targets: '#header, #webdoor' },
			// markers : true
		});
	}

	const webdoorMotion = (el) => {
		gsap.fromTo($(el).not(".no-plx").find('picture'),
			{
				yPercent: 0,
				scale: 1,
			}, {
			yPercent: 35,
			scale: 1.6,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: "bottom -=50%",
				scrub: true,

			}
		});
	}

	const projetistas = () => {

		const imgLine = gsap.utils.toArray('.lineBar');
		const thumbs = gsap.utils.toArray('.thumb img');

		imgLine.forEach((line) => {
			gsap.to(line, {
				scrollTrigger: {
					trigger: line,
					start: "top 75%",
					end: "bottom +=100",
					scrub: true,
					// toggleClass: 'in-view',
					toggleClass: { className: 'in-view', targets: line },
					// markers : true
				}
			})
		});
		
		thumbs.forEach((thumb) => {
			gsap.from(thumb, {
				xPercent: -5,
				scrollTrigger: {
					trigger: thumb,
					start: "top bottom",
					end: "bottom center",
					scrub: true,
					// toggleClass: 'in-view',
					// toggleClass: { className: 'in-view', targets: thumb },
					// markers : true
				}
			})
		});
	}

	const diagEsq = () => {

		const areaGallery = gsap.utils.toArray('.area-gallery');
		const thumbs = gsap.utils.toArray('.thumb img');

		areaGallery.forEach((aGal) => {
			gsap.to(aGal, {
				scrollTrigger: {
					trigger: aGal,
					start: "top 75%",
					end: "bottom +=100",
					scrub: true,
					// toggleClass: 'in-view',
					toggleClass: { className: 'in-view', targets: $(aGal).find('.wrap-diag') },
					// markers : true
				}
			})
		});
		
		/* thumbs.forEach((thumb) => {
			gsap.from(thumb, {
				xPercent: -5,
				scrollTrigger: {
					trigger: thumb,
					start: "top bottom",
					end: "bottom center",
					scrub: true,
					// toggleClass: 'in-view',
					// toggleClass: { className: 'in-view', targets: thumb },
					// markers : true
				}
			})
		}); */
	}

	//-> fade-In Element in scroll View
	const showFade = (classFade) => {
		const bgChange = gsap.utils.toArray(classFade);
		bgChange.forEach((elmFade) => {
			gsap.from(elmFade, {
				scrollTrigger: {
					start: 'top 80%',
					end: '+=100%',
					trigger: elmFade,
					toggleClass: 'in-view',
					// markers : true
				}
			});

		});
	}

	const elmToScroll = function (el) {
		var _this = el.attr('data-scrollto');

		if ($(window).width() < 1000) {
			$("#nav-header, #bt-menu-mobile").removeClass('motion-in');
		}
		scrollToElm(_this);


	}

	const scrollToElm = function (target) {
		var offSTop = (document.getElementById('header').clientHeight - 2);
		/* if(target == '#section-projetos') {
			if($(window).width() > 992) {
				offSTop = 0;
			}
		} */

		gsap.to(window, {
			duration: 2,
			scrollTo: { y: $(target).offset().top - ($(window).width() > 992 ? offSTop : offSTop) },//scrollTo end bracket
			delay: 0,
			ease: 'Power4.easeInOut'
		});

	}

	const navStages = (el) => {

		const _parent = el.closest('.wrap-apts');
		// const widthStageCurrent = _parent.find('.stage-1').width();
		const widthStageNext = _parent.find('.stage-2').width();

		if (el.hasClass('actived')) {
			_parent.animate({
				left: 0
			}, 600, 'swing')
		} else {
			_parent.animate({
				left: - widthStageNext + 'px'
			}, 600, 'swing')
		}

		el.toggleClass('actived');
		el.find('.ico').toggleClass('actived');



	}

	const resizeStages = () => {

		if (screen.width < 992) return;

		$('.wrap-apts').each(function (index) {
			const el = $(this);
			objStage = {
				widthStageCurrent: el.find('.stage-1').width(),
				widthStageNext: el.find('.stage-2').width()
			};

			if (index == 1) {
				el.css('left', -objStage.widthStageNext + "px");
				//el.css('left', "0px");
			}

			return objStage;
		});
	}

	const showMoreText = (el) => {
		let _parent = el.closest('.text');
		_parent.toggleClass('actived');
		if (_parent.hasClass('actived')) {
			el.text('-');
		} else {
			el.text('+');
		}
	}

	const limitWhatsScroll = () => {

		gsap.to("#ico-whats", {
			y: - (document.getElementById("footer").clientHeight),
			scrollTrigger: {
				trigger: "#footer",
				start: "top bottom",
				end: "bottom bottom",
				scrub: true,
				//markers : true
			}
		})
	}

	//-> parallax webdoor
	const parallaxWebdoor = function (el) {

		gsap.fromTo($(el).not(".no-plx").find('picture'),
			{
				yPercent: 0,
				scale: 1,
			}, {
			yPercent: 35,
			scale: 1.6,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: "bottom -=50%",
				scrub: true,

			}
		});
	}

	//-> bg transition scroll View
	const bgTransitionInView = (classBg) => {
		const bgChange = gsap.utils.toArray(classBg);
		bgChange.forEach((bgs) => {
			gsap.from(bgs, {
				scrollTrigger: {
					start: 'top 65%',
					end: 'bottom top',
					trigger: bgs,
					toggleClass: 'in-view'
				}
			});
		});
	}



	//-> layer image in scroll View
	const layerImg = (classLImg, classIText) => {
		const bgChange = gsap.utils.toArray(classLImg);
		bgChange.forEach((classLImg) => {
			gsap.from(classLImg, {
				scrollTrigger: {
					start: 'top center',
					//end: '+=100%',
					trigger: classLImg,
					toggleClass: 'in-view',
					// markers : true
				}
			});
			const introText = gsap.utils.toArray(classIText);
			introText.forEach((intTxt) => {
				gsap.from(intTxt, {
					scrollTrigger: {
						start: 'center 80%',
						end: '+=100%',
						trigger: intTxt,
						toggleClass: 'in-view',
						// markers : true
					}
				});
			});
		});
	}

	//-> text show in scroll View
	const introText = (classIText) => {
		/* const bgChange = gsap.utils.toArray(classIText);
		bgChange.forEach((classIText) => {
			gsap.from(classIText, {
				scrollTrigger: {
					start: 'top center',
					end: '+=100%',
					trigger: classIText,
					toggleClass: 'in-view',
					// markers : true
				}
			});
		}); */
	}

	const expImage = (() => {
        gsap.utils.toArray(".revealUp").forEach(el => {
            gsap.fromTo(el,
                {
                    scale: 1.1,
                    yPercent: -35
                }, {
                yPercent: 0,
                scale: 1,
                autoAlpha: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    start: "top 50%",
                    end: "bottom bottom",
                    scrub: 2
                }
            });
        })

    })

	const startCounters = () => {
		gsap.utils.toArray('.storage_numer').forEach(el => {
			gsap.from(el,
				{
					innerText: 0,
					duration: 5,
					snap: {
						innerText: 0.1
					},
					scrollTrigger: {
						trigger: $(el).closest('.wrap-counters'),
						start: "top bottom",
						end: "bottom bottom",
						scrub: 2,
						// markers : true
					}
				},
			);
		})
	}


	return {
		init: () => {

			webdoorMotion(".webdoor");
			scrollHeader();
			projetistas();
			diagEsq();
			resizeStages();
			limitWhatsScroll();
			startCounters();

			$(document).on('click', '[data-scrollto]', function (e) {
				e.preventDefault();
				elmToScroll($(this));
			});

			// $('.nav-stage').on('click', function(){
			// 	navStages($(this));
			// })

			/* $('.btn-img-plant').on('click', function(e){
				e.preventDefault();
				$('.btn-img-plant').removeClass('actived');
				const selected = $(this).attr('data-plant');
	
				// show image selected
				$(this).closest('.stages').find('.thumb-plant, .legend-apto-plant').hide();
				$('.thumb-plant[data-plant-img='+ selected +']').show();
				$('.legend-apto-plant[data-slide='+ selected +']').show();
				$(this).addClass('actived');
	
				// show legend selected
	
			}) */

			$('.text-more').on('click', function () {
				showMoreText($(this));
			})

			if ($('.showFade').length > 0)
				showFade('.showFade');
			
			if ($(".revealUp").length > 0)
				expImage();

			/* if ($(".webdoor").length > 0)
				parallaxWebdoor(".webdoor");


			if ($('.bg-transition').length > 0)
				bgTransitionInView('.bg-transition');

			

			if ($('.wrap-picture-img-parallax').length > 0)
				layerImg('.wrap-picture-img-parallax', '.text-intro');
 */
			/* 			if($('.text-intro').length > 0)
							introText('.text-intro');
			 */

			if ($('.bg-transition').length > 0)
				bgTransitionInView('.bg-transition');

			ScrollTrigger.refresh();
		}
	}

}();

export default windowScrollPage;